import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  Popover,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { colorSchemes, crossIcon, crossIconDiv, fontSizeSchemes } from "../../../assets/commonFunction";
import CloseIcon from "@mui/icons-material/Close";
const DateRangePicker = ({ 
  open, 
  anchorEl, 
  onClose, 
  onApply, 
  selectedDateRange,
  setSelectedDateRange 
}) => {
  const [startDate, setStartDate] = useState(selectedDateRange?.startDate || null);
  const [endDate, setEndDate] = useState(selectedDateRange?.endDate || null);

  const handleApply = () => {
    if (startDate && endDate) {
      onApply({
        startDate: dayjs(startDate).format('DD-MM-YYYY'),
        endDate: dayjs(endDate).format('DD-MM-YYYY')
      });
      onClose();
    }
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    onApply(null);
    onClose();
  };

  const handleClose = () => {
    // If dates were selected but not applied, clear them
    if (startDate || endDate) {
      setStartDate(null);
      setEndDate(null);
      onApply(null);
    }
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          mt: 1,
          p: 2,
          minWidth: 300,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          borderRadius: '8px',
        }
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={2}>
         <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center",mb:1}}>
          <Typography
            sx={{
              fontSize: fontSizeSchemes.font14,
              fontWeight: "600",
              color: colorSchemes.black,
              
            }}
          >
            Select dates
          </Typography>
          <Box onClick={handleClose} sx={{...crossIconDiv}}>
            <CloseIcon sx={{...crossIcon}} />
          </Box>
          </Box>
          
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            maxDate={endDate || undefined}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  "& .MuiOutlinedInput-root": {
                    fontSize: fontSizeSchemes.font13,
                  }
                }
              }
            }}
          />
          
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            minDate={startDate || undefined}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  "& .MuiOutlinedInput-root": {
                    fontSize: fontSizeSchemes.font13,
                  }
                }
              }
            }}
          />
          
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              onClick={handleClear}
              sx={{
                fontSize: fontSizeSchemes.font12,
                textTransform: "none",
                color: colorSchemes.black,
                border: `1px solid ${colorSchemes.black}`,
                borderRadius: "3px",
                px: 2,
                py: 0.5,
              }}
              variant="outlined"
            >
              Clear
            </Button>
            <Button
              onClick={handleApply}
              disabled={!startDate || !endDate}
              sx={{
                fontSize: fontSizeSchemes.font12,
                textTransform: "none",
                backgroundColor: colorSchemes.black,
                color: "white",
                borderRadius: "3px",
                px: 2,
                py: 0.5,
                "&:hover": {
                  backgroundColor: colorSchemes.black,
                },
                "&:disabled": {
                  backgroundColor: "#ccc",
                  color: "#666",
                }
              }}
              variant="contained"
            >
              Apply
            </Button>
          </Stack>
        </Stack>
      </LocalizationProvider>
    </Popover>
  );
};

export default DateRangePicker; 